import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  listContent: {
    padding: spacing.m,
  },
  listHeader: {
    marginBottom: spacing.m,
  },
}));
